/**
* Functions for dealing with css classes
* @package Utils
* 
* - vunger	080428	Added GetTop(), GetLeft()
* - msmaga	080507	Moved Comments drop-down from GenerateReport
* - msmaga	080509	jsEncoding for AjaxFormSubmit
* - thoare	080530	Implemented importNode() and node type constants for those browsers (IE!) which lack it.
* - msmaga 	080624	added pickComment()
* - vunger 	081208	added CheckForInteger()
* - shashagen 073109 After save, don't redirect until all responses when there are multiple forms on page
* - jmedellin	090819	added support for launching into Aqua
* - jmedellin 091106 	Added support for ViewingMode
* - jmedellin 052710	Added support for limiting amount of text in each field of list view
* -	vunger	100604	Added SaveQueue
* -	vunger	100711	Moved Save functions to Saves.js
* - jmedellin 101014	Added support for show/hide function
* - rellis	140409	Added Mode parameter (RUO/IVD) to SingleViewWithImageScopeOrBrowser 
* - rellis	141218	added support for W and Alt W when clicking on an image link
* - cboarman 150424 removed conferencing logic - now consolidated into conferencing stream and imported
*/
// Globals
OverrideSaveCheck = false;
IMAGESCOPE = 'ImageScope';
WEBSCOPE   = 'WebScope';
WEBVIEWER  = SystemParms.WebViewerTargetFrameName || 'WebViewer';    // formerly uScope
IMAGETYPEREGULAR      = '1';
IMAGETYPEMARKUP       = '2';
IMAGETYPEZSTACK       = '3';
IMAGETYPEMONTAGE      = '4';
IMAGETYPECLASSLABEL   = '5';
IMAGETYPECOMPONENT    = '6';

function hasClass(Element, ClassName)
{
	var Classes = [];
	if (typeof (Element.className) == 'undefined')
	{
		return false;
	}
	if (typeof (Element.className.split) != 'function')
	{
		Classes = new Array(Element.className);
	}
	else
	{
		Classes = (Element.className != '' ? Element.className.split(' ') : new Array());
	}
	for ( var i = 0; i < Classes.length; i++)
	{
		if (Classes[i] == ClassName)
		{
			return true;
		}
	}

	return false;
}

function addClass(Element, ClassName)
{
	if (Element.className == '')
	{
		Element.className = ClassName;
	}
	else if (!hasClass(Element, ClassName))
	{
		Element.className += ' ' + ClassName;
	}
}

function removeClass(Element, ClassName)
{
	var Classes = (Element.className != '' ? Element.className.split(' ') : new Array());
	var Spacer = '';

	Element.className = '';

	for ( var i = 0; i < Classes.length; i++)
	{
		if (Classes[i] != ClassName)
		{
			Element.className += Spacer + Classes[i];
			Spacer = ' ';
		}
	}
}

// Recursively find the element with a class of 'ClassName'
function FindElementWithClass(Element, ClassName)
{
	if (Element)
	{
		var Children = Element.childNodes;
		if (Children)
		{
			for ( var i = 0; i < Children.length; i++)
			{
				if (hasClass(Children[i], ClassName))
				{
					return Children[i];
				}
			}
			for ( var j = 0; j < Children.length; j++)
			{
				var ElementRecursive = FindElementWithClass(Children[j], ClassName);
				if (ElementRecursive)
				{
					return ElementRecursive;
				}
			}
		}
	}
	return null;
}

function getAttribute(Element, Attr)
{
	return $(Element).attr(Attr);
}

// Recursively find the element with a attribute of passed value
function FindElementWithAttribute(Element, Attr, AttrVal)
{
	if (Element)
	{
		var Children = Element.childNodes;
		if (Children)
		{
			for (var i = 0; i < Children.length; i++)
			{
				if (getAttribute(Children[i], Attr) == AttrVal)
					return Children[i];
			}
			for (var i = 0; i < Children.length; i++)
			{
				var ElementRecursive = FindElementWithAttribute(Children[i], Attr, AttrVal);
				if (ElementRecursive)
				{
					return ElementRecursive;
				}
			}
		}
	}
	return null;
}

function FindParentWithTag(Element, TagName)
{
	var TagName = TagName.toLowerCase();
	while ((Element != null) && (Element.tagName != null) && (Element.tagName.toLowerCase() != TagName))
	{
		Element = Element.parentNode;
	}
	return Element;
}

function Cancel()
{
	history.go(-1);
}

// Copy the item
function Clone(item)
{
	if (jQuery.isArray(item))
		return jQuery.extend([], item);
	if (typeof item == "object")
		return jQuery.extend({}, item);
	else
		return item;
}

// -----------------------------------------------------
// AJAX funxtions
// -----------------------------------------------------

function HTTPRequest(URL, Method, Parameters, Ready, FunctionName)
{
	var http_request = false;

	if (window.XMLHttpRequest)
	{ // Most browsers now support this
		http_request = new XMLHttpRequest();
		if (http_request.overrideMimeType)
		{
			http_request.overrideMimeType('text/xml');
		}
	}
	else if (window.ActiveXObject)
	{
		try
		{
			http_request = new ActiveXObject("Msxml2.XMLHTTP");
		}
		catch (e)
		{
			try
			{
				http_request = new ActiveXObject("Microsoft.XMLHTTP");
			}
			catch (e)
			{
			}
		}
	}

	if (!http_request)
	{
		alert('Cannot create an XMLHTTP instance');
		return false;
	}

	// Note: running AJAX synchronously will hang the PHP debugger NuSphere
	var bAsync = true;

	if (Ready == null)
	{
		bAsync = false;
	}
	else if (typeof Ready == 'function')
	{
		http_request.onreadystatechange = function()
		{
			Ready(http_request);
		};
	}
	else if ((typeof Ready == 'object') && (typeof FunctionName == 'undefined'))
	{
		http_request.onreadystatechange = function()
		{
			Ready.Receive(http_request);
		};
	}
	else if ((typeof Ready == 'object') && (typeof FunctionName == 'string'))
	{
		http_request.onreadystatechange = function()
		{
			Ready[FunctionName](http_request);
		};
	}
	else
	{
		alert('Invalid AJAX callback parameters');
	}

	Parameters += "&AJAX=1";

	http_request.open(Method, URL, bAsync);
	http_request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	http_request.send(Parameters);
	if (bAsync)
	{
		return true;
	}
	return http_request.responseText;
}

function parseXML(XMLString)
{
	var xmlDoc = null;

	try
	{
		xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
		xmlDoc.async = "false";
		xmlDoc.loadXML(XMLString);
	}
	catch (e)
	{
		try
		{
			parser = new DOMParser();
			xmlDoc = parser.parseFromString(XMLString, "text/xml");
		}
		catch (e)
		{
			alert(e.message);
		}
	}

	return xmlDoc;
}

// -----------------------------------------------------
// TIMER LOGIC
// -----------------------------------------------------
var timerID = 0;

// All pages including this script will check for a conference invite (assuming user permissions)
var dscTimer = 0;

// Global variable to be overridden
var BaseLocation = "";

function StartTimer()
{
	if (SystemParms.SessionCheckInterval != 0)
	{
		timerID = setTimeout(function() {
			HTTPRequest ('/SessionActive.php', 'POST', '', CheckSession);
		}, SystemParms.SessionCheckInterval * 1000);
	}
	if (SystemParms.DSCInterval != 0)
	{
		dscTimer = setInterval(CheckForConferenceInvite, SystemParms.DSCInterval * 1000);
	}
	// else do not poll for dsc invites. One DscAvail_Get poll happens anyway every time MastheadHeader.php is loaded.
}

function StopTimer()
{
	if (timerID)
	{
		clearTimeout(timerID);
		timerID = 0;
	}
	if (dscTimer)
	{
		clearInterval(dscTimer);
		dscTimer = 0;
	}
}

function CheckForConferenceInvite()
{
	if (undefined !== SystemParms.UserId)
	{
		// If leica.pi.util.conference is defined, then check for conference invites 
		if ('undefined' !== typeof leica.pi.util.conference )
		{
			// This will do nothing if the user is busy or does not have conference join permission
			leica.pi.util.conference.getConferenceInvitation(SystemParms.UserId);
		}

	}
}

function CheckSession(http_request)
{
	if ((http_request.readyState == 4) && (http_request.status == 200))
	{
		var Data = ParseAjaxResponse(http_request.responseText);
		if (undefined != Data) {
			if (undefined != Data.Session) {
				if (Data.Session == 'Inactive')
				{
					return LogOff('Session Timeout');
				}
			}
			else
			{
				alert(Data);
			}
		}
		else {
			console.log('CheckSession: Bad Response: "' + http_request.responseText + '"');
		};

		StartTimer(); // if we did not logoff, restart the timer
	}
}

function LogOff(Message)
{
    if (dscTimer) {
		clearInterval(dscTimer);
	}
	OverrideSaveCheck = true;
	var LogoffPage = BaseLocation + "/LogOff.php?";
	if (Message == 'Session Timeout')
	{
		LogoffPage += 'timeout=true';
	}
	else
	{
		LogoffPage += 'message=' + Message;
	}
	window.location = LogoffPage;
}

// Emulate a form submission for the passed element
function SendPost(Path, Name)
{
	var Element = document.getElementById(Name);

	Method = "post";

	// The rest of this code assumes you are not using a library.
	// It can be made less wordy if you use one.
	var form = document.createElement("form");
	form.setAttribute("method", Method);
	form.setAttribute("action", Path);

	var Parms = GetInputs(Element);
	for ( var i in Parms)
	{
		var Parm = Parms[i];
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", Parm.name);
		hiddenField.setAttribute("value", Parm.value);

		form.appendChild(hiddenField);
	}

	document.body.appendChild(form); // Not entirely sure if this is
	// necessary
	form.submit();
}

function isset(variable)
{
	var undefined;
	return (variable === undefined ? false : (variable !== null));
}

function GetFolderPath()
{
	var Folder;
	Folder = prompt("Specify a destination folder (e.g. \\\\servername\\sharename)", "");
	if ((Folder == "") || (Folder == null))
	{
		return false;
	}
	else
	{
		document.BulkForm.DestinationFolder.value = Folder;
		return true;
	}

}

function SortList(sSortField, sSortOrder)
{
	document.ReSubmitSearchForm.SortField.value = sSortField;
	document.ReSubmitSearchForm.SortOrder.value = sSortOrder;
	document.ReSubmitSearchForm.PageNumber.value = 1;
	document.ReSubmitSearchForm.submit();
}

/**
 * Check for Flash Player in Firefox - if its too old or not installed, give the user a link to download the latest version from Adobe.
 * Note that Chrome and IE10+ maintain their own internal version of Flash Player, and are in general more Flash-friendly.
  */
function CheckFlashInstalled ()
{
	// If using Firefox, a too old or not installed Flash Player means it'll be missing from navigator.plugins.
    if (IsFF() && (!navigator.plugins || navigator.plugins.length === 0 || !navigator.plugins["Shockwave Flash 2.0"] && !navigator.plugins["Shockwave Flash"]))
    {
        document.write('<h3 class="error">This page requires Flash Player. <b><a href="https://get.adobe.com/flashplayer" target="_blank">Click here to get the latest version</a> or (if already installed) <a href="#" onclick="alert(\'Open a new tab and navigate to \\n\\nabout:addons\\n\\nIf Shockwave Flash is listed, try enabling this site.\')">update your Flash Player settings.</a></b></h3>');
        return false;
    }
    return true;
}
function IsAquaInstalled()
{
	// This function is used to determine if Aqua is installed on the
	// client machine. There are two ways to do this... Under windows and IE
	// we can <method TBD>. Under all other browsers, we have to
	// check the MIME types for "text/hris".
	// Remove bypass when complete!

	if (SystemParms.AquaEnabled == '0')
		return false;

	if (!isSupported)
	{
		return false;
	}
							  
	var aquaIsInstalled = false;
	if (IsWin() && IsIE())
	{
		// IE on windows...
		try
		{
			var hrx = new ActiveXObject("HistoRX.AperioPush.AperioResultData");
			aquaIsInstalled = true;
		}
		catch (e)
		{   
		}
	}
	else if ((navigator.mimeTypes.length > 0) && navigator.mimeTypes["text/hris"])
	{
		// non-ie browsers can check the MIME types.
		aquaIsInstalled = true;
	}
	return aquaIsInstalled;
}

function IsTSInstalled()
{
	// This function is used to determine if TissueStudio is isntalled on the
	// client machine. There are two ways to do this... Under windows and IE
	// we can <method TBD>. Under all other browsers, we have to
	// check the MIME types for "text/diasis".
	// Remove bypass when complete

	if (SystemParms.TissueStudioEnabled == '0')
		return false;

	/*
	 * if(!isSupported) return;
	 */
	var tsIsInstalled = false;

	if (IsWin() && IsIE())
	{
		// IE on windows...
		try
		{
			var ts = new ActiveXObject("TSReg.TSRegObj.1");
			tsIsInstalled = true;
		}
		catch (e)
		{  
		}
	}
	else if ((navigator.mimeTypes.length > 0) && navigator.mimeTypes["text/diasis"])
	{
		// non-ie browsers can check the MIME types.
		tsIsInstalled = true;
	}
	return tsIsInstalled;
}

function IsWin()
{
	var agt = navigator.userAgent.toLowerCase();
	return (agt.indexOf("win") != -1);
}

function IsIE()
{
    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent))       //detect IE < 11.0
        return true;
    if (/Trident.*rv[ :]*11\./.test(navigator.userAgent))   //detect IE 11
        return true;
}

function IsFF()
{
	return (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent));
}

function IsChrome()
{
	return (/Chrome[\/\s](\d+\.\d+.\d+\.\d+)/.test(navigator.userAgent));
}
function IsString(obj)
{
	return obj && (typeof (obj) == 'string');
}

function IsArray(obj)
{
	return obj && (obj.constructor == Array);
}

function viewImage(ImageId)
{
	var Viewer = ChooseViewer(null);
	if (Viewer == IMAGESCOPE)
		window.open('/ViewImage.php?ImageId=' + ImageId + '&UseImageScope=1');
	else if (Viewer == WEBVIEWER)
		window.open('eSlideTray.php?Images=' + ImageId, WEBVIEWER);
	else if (Viewer == WEBSCOPE)
        window.open('/ViewImage.php?ImageId=' + ImageId);
}

function ChooseViewer(ClickedElement)
{
	var viewer = SystemParms.DefaultImageViewer;
	if (iPressed || (isset(ClickedElement) && $(ClickedElement).closest('a').attr('imagetypeid') == IMAGETYPEMONTAGE))
	{
		// either I is pressed, or the image is a Genie Montage, return the imagescope viewer
		viewer = IMAGESCOPE;
	}
	else if (wPressed)
	{
		// W is pressed, return the webviewer viewer
		viewer = WEBVIEWER;
	}
	else if (aPressed)
	{
		// A is pressed, return the webscope viewer
		viewer = WEBSCOPE;
	}
	// special checks for the web based viewers   
	if (viewer == WEBVIEWER || viewer == WEBSCOPE)
	{
		if (SystemParms.SessionMode == 'IVD')
		{
			alert(viewer + ' is disabled in IVD mode');
			viewer = null;
		}
		else if (SystemParms.WebViewerEnabled != '1')
		{
			alert(viewer + ' is disabled');
			viewer = null;
		}
	}
	wPressed = false;
	aPressed = false;
	iPressed = false;

	return viewer;
}

function GetHostNameAndPort()
{
	var host = location.hostname;
	if (isset(location.port) && (location.port != ''))
	{
		host += ':' + location.port;
	}
	return host;
}

/**
 * NOTE: CONSTRAINT: DO NOT CHANGE: the first and last parameters must remain (single-quote wrapped) Strings.
 *       For compatibility with ePathViewer, which expects that type and format (i.e. single quotes, not double)
 *       in order to parse eSM's slide list to populate its own.
 * 		 Specifically, ePV's regex seeks a start string of "SingleViewWithImageScopeOrBrowser ('" and an end String
 * 		 of "')" (that is, a single quote followed by a closing parenthesis).
 * 		 If you must add new params (that are not single-quote wrapped Strings), do NOT make them first or last in the param list.
 */
function SingleViewWithImageScopeOrBrowser(ImageServerURL, ImageId, ViewingMode, ClickedElement, Mode)
{
	// this TableName logic is just temporary until we get the AIL change to
	// have spots as ImageIds
	/*
	 * var TableName; if (location.href.indexOf("EditCore.php") != -1) TableName =
	 * "Spot"; else
	 */
	var TableName = "Image";

	// view a single slide in a viewer.
	var Viewer = ChooseViewer(ClickedElement);
	if (Viewer == IMAGESCOPE)
	{
		NeedCheck = false;

		// ImageScope is installed so request a SIS file
		location.replace('/BulkAction.php?Command=BulkImageScopeView&HostName=' + GetHostNameAndPort() + '&ImageIds[]=' + ImageId + '&TableName=' + TableName);

		NeedCheck = true;
	}
	else if (Viewer == WEBVIEWER)
	{
		// view image in uScope - now called WebViewer
		var Options = '';
		var subSection = $(ClickedElement).closest('.SubSection');
		if (subSection.length > 0)
		{
			// this is a details page (EditRecord.php)
			var subSectionId = subSection.attr('id');
			// Always set DisplayTopLevel=true & DisplayHeader=true on the edit record page,
			// except for Specimen Gross Images and TMA spot images. This is to maintain consistency between
			// WebViewer and the other viewers, which open the Gross Image, and not
			// the top level table. per email from product manager Colin Doolan, 11/18/2014
			if (subSectionId != 'divShowImagesSpecimen' && subSectionId != 'divShowChildSpot')
			{
				Options = '&DisplayTopLevel=true&DisplayHeader=true';
			}
		} 
		/**
		else
		{
			// This is not a details page, so don't DisplayTopLevel.
			// get table name from #ListSlide or #ListSpecimen, etc.
			// exclude ListHeaderRow from the selector
			TableName = $('div[id^="List"][id!="ListHeaderRow"]').first().attr('TableName');
		}
		**/
		window.open('eSlideTray.php?ImageIds=' + ImageId + Options, WEBVIEWER);
	}
	else if (Viewer == WEBSCOPE)
	{
		window.open('/ViewImage.php?ImageId=' + ImageId);
	}
}

function MultiViewWithImageScopeOrBrowser(ImageServerURLs, ImageIds, ViewingMode)
{
	// view multiple slides in ImageScope. If ImageScope
	// is not installed then view in browser.

	var Viewer = ChooseViewer(null);
	if (Viewer == IMAGESCOPE)
	{
		NeedCheck = false;

		// ImageScope is installed so request a SIS file
		var ViewURL = '/BulkAction.php?Command=BulkImageScopeView&HostName=' + GetHostNameAndPort();
		var Args = '';

		for ( var i = 0; i < ImageIds.length; i++)
		{
			if (ImageIds[i] != -1)
			{
				Args += '&ImageIds[]=' + ImageIds[i];
			}
		}

		if (Args.length > 0)
		{
			location.replace(ViewURL + Args);
		}

		NeedCheck = true;
	}
	else if (Viewer == WEBVIEWER)
	{
		var parms = ImageIds.length != 0 ? '?ImageIds=' + ImageIds.join(",") : '';
		window.open('eSlideTray.php'+parms, WEBVIEWER);
	}
	else if (Viewer == WEBSCOPE)
	{
		// ImageScope is not installed so view image in browser (WebScope)
		for ( var i = 0; i < ImageIds.length; i++)
		{
			if (ImageIds[i] != -1)
			{
				URL = ImageServerURLs[i] + '/@' + ImageIds[i] + '/view.apml';
				if ((ViewingMode != 0) && (ViewingMode != undefined))
				{
					URL += "?ViewingMode=" + ViewingMode;
				}
				window.open(URL, 'Image' + ImageIds[i], '');
			}
		}
	}
}


/*
* View a specimen gross image in a new browser page
*/
function ViewGrossImageInBrowser(ImageServerURL,SpecimenLabel)
{
	URL = "/ViewGrossImage.php?ImageURL=" + ImageServerURL + "&SpecimenLabel=" + encodeURIComponent(SpecimenLabel);
	window.open(URL, 'GrossImage', 'scrollbars=1');
}

function trim(sString)
{
	while (sString.substring(0, 1) == ' ')
	{
		sString = sString.substring(1, sString.length);
	}
	while (sString.substring(sString.length - 1, sString.length) == ' ')
	{
		sString = sString.substring(0, sString.length - 1);
	}
	return sString;
}

function ForceToNumber(Value, MinValue, MaxValue, Step)
{

	if (typeof(Value) == 'string') {
        Value = parseInt(Value);
	}
	if (typeof(Value) == 'number') {
        // Test for NaN
        if (Value != Value) {
           Value = MinValue;
        }
	}
	else
	{
		Value = MinValue;
	}

	if ((MinValue != null) && (Value < MinValue))
	{
		Value = MinValue;
	}
	else if ((MaxValue != null) && (Value > MaxValue))
	{
		Value = MaxValue;
	}

	if (Step != null)
	{
		var Base = (MinValue != null) ? MinValue : ((MaxValue != null) ? MaxValue : 0);

		Value = Base + (Math.round((Value - Base) / Step) * Step);
	}

	return Value;
}

function CheckModified(Element)
{
	var Modified = false;
	if ((Element.tagName == 'INPUT') || (Element.tagName == 'SELECT') || (Element.tagName == 'TEXTAREA'))
	{
		Modified = CheckElement(Element);
	}
	else
	{
		var Inputs = GetInputs(Element);		

		for ( var i = 0; i < Inputs.length; i++)
		{
			Modified = CheckElement(Inputs[i]) || Modified;
		}

		return Modified;
	}

	if (Modified == false)
	{
		return false;
	}

	if (ModifyOK(Element))
	{
		// don't set ModifiedTab if the field is in a jQuery modal dialog
		if ($(Element).closest('.ui-dialog-content').length == 0)
		{
			$('[aria-selected="true"]').children().addClass('ModifiedTab');
		}
		return true;
	}

	if ((Element.tagName == 'INPUT') || (Element.tagName == 'SELECT') || (Element.tagName == 'TEXTAREA'))
	{
		RevertElement(Element);
	}
	else
	{
		var Inputs = GetInputs(Element);
		for ( var i = 0; i < Inputs.length; i++)
		{
			RevertElement(Inputs[i]) || Modified;
		}
	}

	return false;
}

function ModifyOK(Element)
{
	var ApprovalType = Element.getAttribute('getapproval');
	{
		if (ApprovalType == 'Child')
		{
			if (FindElementWithAttribute(document, 'sspconfig', '1') == null)
				return true;

			PromptText = 'All previously calculated Analysis, Score, and Interpretation data for all slides that do not override this field will be erased.  Please notify the responsible party IMMEDIATELY if an affected slide has already been analyzed';
		}
		else if (ApprovalType == 'Self')
		{
			PromptText = 'All previously calculated Analysis, Score, and Interpretation data for this slide will be erased. Please notify the responsible party IMMEDIATELY if this slide has already been analyzed';
		}
		else
		{
			return true;
		}

		// FF will fire both a KeyUp and then an onChange once the prompt is up.
		// This will prevent the double prompting of the user.
		Element.setAttribute('getapproval', '');

		var approved = confirm(PromptText);
		if (approved)
		{
			// Once the user has OK'd a change for this field do not prompt again
			return true;
		}
		// else
		// Restore the approval
		Element.setAttribute('getapproval', PromptText);
		return false;
	}
}

// this function is used in Advanced Search form where the search value is turned into a checkbox on/off option
// The goal is to set 'FieldValue[]' hidden field  to 0 or 1 based on the checkbox 
// the 'FieldValue[]' hidden field  is generated right after that checkbox so it should be ''nextSibling'
// there is a conflict on IE8, IE9 and Firefox  when 'nextSibling' is used.
// In IE 8 there is one extra node generated right under the current field, so  to check for the valid nextSibling element need to check on its name as well
// So the following will avoid errors and send the correct search criteria from all of the browsers
// get window.event if event is not set (in IE)
// get srcElement if target is not set (in IE)
function GetNextSibling(ThisEvent)
{   
	ThisEvent = ThisEvent || window.event;
	var targetElement = ThisEvent.target || ThisEvent.srcElement;
	// get the next input field
	var NextElement = targetElement.nextSibling;
	if ( NextElement == 'undefined')
	{  // in case event not captured, never should happen
		return;
	}
	var position = 1;
	//In IE 8 there is one more node generated right under the current field
	// so need to skip it and it should be next item
	while (NextElement.name != 'FieldValue[]' && position != 2)
	{
		NextElement = NextElement.nextSibling;
		position += 1;	  
	}
		
	NextElement.value = targetElement.checked ? "1" : "0";
}


function CheckElement(Element)
{
	if (Element.getAttribute('oldvalue') != undefined)
	{
		var OldValue = Element.getAttribute('oldvalue');
		var NewValue = Element.value;

		removeClass(Element, 'Invalid');

		if (OldValue === NewValue)
		{
			removeClass(Element, 'Modified');		// FieldModified
			removeClass(Element, 'FieldError');

			var Label = document.getElementById(Element.id + '.Label');
			if (Label)
			{
				Label.innerHTML = '';
			}

			return false;
		}
		else
		{
			addClass(Element, 'Modified');		// FieldModified
			return true;
		}
	}
	return true;
}

function RevertElement(Element)
{
	var oldValue = Element.getAttribute('oldvalue');
	if (oldValue != null)
	{
		if (Element.tagName == 'SELECT')
		{
			var options = Element.getElementsByTagName('OPTION');
			for ( var i = 0; i < options.length; i++)
			{
				if (options[i].selected)
				{
					if (options[i].value != oldValue)
					{
						options[i].selected = false;
					}
				}
				else
				{
					if (options[i].value == oldValue)
					{
						options[i].selected = true;
					}
				}
			}
		}
		else
		{
			Element.value = oldValue;
		}
	}
}

function HideSpectrumMessageBox()
{
	var divMsg = document.getElementById('idDivMessage');

	if (divMsg)
	{
		divMsg.style.display = 'none';
	}

	return true;
}

function SpectrumMessageBox(sText)
{	
	$('#idDivMessage').remove();
	$('<div id="idDivMessage" class="MessageBox" style="z-index:9999">' + sText  + '</div>').appendTo("body");
	//put the message box in the center of the window
	$('#idDivMessage').position({
		of: $(window),
		at: "center"
	});	
	return true;
}

function EventTarget(e)
{
	var targ;
	if (!e)
	{
		var e = window.event;
	}

	if (e.target)
	{
		targ = e.target;
	}
	else if (e.srcElement)
	{
		targ = e.srcElement;
	}

	if (targ.nodeType == 3)
	{
		targ = targ.parentNode;
	}

	return targ;
}

function GetInputs(Element)
{
	var i = 0;
	var RetArray = new Array();

	// beforeunload uses <body> to and walks the entire page looking for changed
	// <inputs>
	if (document.ELEMENT_NODE === Element.nodeType || document.DOCUMENT_NODE === Element.nodeType)
	{
		var Inputs = Element.getElementsByTagName('INPUT');
		var TextAreas = Element.getElementsByTagName('TEXTAREA');
		var Selects = Element.getElementsByTagName('SELECT');

		if (document.ELEMENT_NODE === Element.nodeType)
		{
			// if the element is a textnode return
			if (undefined === Element.tagName)
			{
				return;
			}
			if ('input' === Element.tagName.toLowerCase() || 'textarea' === Element.tagName.toLowerCase() || 'select' === Element.tagName.toLowerCase())
			{
				RetArray.push(Element);
			}
		}
		else
		{
			RetArray.push(Element);
		}

		for (i = 0; i < Inputs.length; i++)
		{
			RetArray.push(Inputs[i]);
		}
		for (i = 0; i < TextAreas.length; i++)
		{
			RetArray.push(TextAreas[i]);
		}
		for (i = 0; i < Selects.length; i++)
		{
			RetArray.push(Selects[i]);
		}
	}
	return RetArray;
}

function ResetInputs(Form)
{
	var Inputs = GetInputs(Form);
	var TableName = '';

	for ( var i = 0; i < Inputs.length; i++)
	{
		if (Inputs[i].name == 'TableName')
		{
			TableName = Inputs[i].value;
		}
	}

	for ( var i = 0; i < Inputs.length; i++)
	{
		if (hasClass(Inputs[i], 'Modified'))		// FieldModified
		{
			switch (Inputs[i].tagName.toUpperCase())
			{
				case 'SELECT' :
					for ( var j = 0; j < Inputs[i].options.length; j++)
					{
						if (Inputs[i].options[j].value == Inputs[i].getAttribute('oldvalue'))
						{
							Inputs[i].selectedIndex = j;
						}
					}

					break;
				case 'INPUT' :
					Inputs[i].value = Inputs[i].getAttribute('oldvalue');

					switch (Inputs[i].type.toUpperCase())
					{
						case 'CHECKBOX' :
							Inputs[i].checked = (Inputs[i].value == '1');
							break;
					}
					break;
				case 'TEXTAREA' :
					Inputs[i].value = Inputs[i].getAttribute('oldvalue');
					break;
			}

			removeClass(Inputs[i], 'Modified');		// FieldModified
			removeClass(Inputs[i], 'FieldError');

			var Label = document.getElementById(TableName + '.' + Inputs[i].name + '.Label');
			if (Label)
			{
				Label.innerHTML = '';
			}
		}
	}

	return false;
}

function AddParmsToForm(Form, Parms)
{
	var ParmArray = Parms.split('&');
	for ( var i = 0; i < ParmArray.length; i++)
	{
		var Parm = ParmArray[i];
		var KeyVal = Parm.split('=');
		if (KeyVal.length == 2)
		{
			var hiddenField = document.createElement("input");
			hiddenField.setAttribute("type", "hidden");
			hiddenField.setAttribute("name", KeyVal[0]);
			hiddenField.setAttribute("value", KeyVal[1]);
			Form.appendChild(hiddenField);
		}
	}
}

var startY = 200;
var sy;
function ScrollPopups()
{
	if (document.documentElement.scrollTop)
	{
		sy = document.documentElement.scrollTop;
	}
	else
	{
		sy = document.body.scrollTop;
	}

	var temp = sy + startY;
	var newY = temp.toString() + "px";

	var esigWindow = document.getElementById("esigDiv");
	if (esigWindow)
	{
		esigWindow.style.top = newY;
	}

	var rfcWindow = document.getElementById("rfcDiv");
	if (rfcWindow)
	{
		rfcWindow.style.top = newY;
	}
}

function getElementsByClass(getClass)
{
	var elementsArray = [];
	var matchedArray = [];
	var expression = new RegExp("(^| )" + getClass + "(|$)");

	if (document.all)
	{
		elementsArray = document.all;
	}
	else
	{
		elementsArray = document.getElementsByTagName("*");
	}

	for ( var i = 0; i < elementsArray.length; i++)
	{
		if (expression.test(elementsArray[i].className))
		{
			// var includedElement = elementsArray[i];
			matchedArray[matchedArray.length] = elementsArray[i];
		}
	}
	return matchedArray;
}

function GetFormOf(Element)
{
	alert(Element.tagName);
	while (Element && (Element.tagName != 'FORM'))
	{
		Element = Element.parentNode;
	}

	return Element;
}

function GetTop(inputObj)
{
	var returnValue = inputObj.offsetTop;

	while ((inputObj = inputObj.offsetParent) != null)
	{
		returnValue += inputObj.offsetTop;
	}

	return returnValue;
}

function GetLeft(inputObj)
{
	var returnValue = inputObj.offsetLeft;

	while ((inputObj = inputObj.offsetParent) != null)
	{
		returnValue += inputObj.offsetLeft;
	}

	return returnValue;
}
/* for comment drop-down/add-ins: */

function CloseCommentMenu()
{
	if (PreventClose == 1)
	{
		PreventClose = 0;
	}
	else
	{
		document.getElementById('CannedMenu').style.display = 'none';
	}
}

function Select(TextArea, sType)
{
	PreventClose = 1; // set an override to prevent the menu from being closed
	SelectedTextArea = TextArea;

	var xy = findPos(TextArea);
	var CannedMenu = document.getElementById('CannedMenu');

	CannedMenu.style.display = ''; // show the menu

	CannedMenu.style.left = xy[0]; // move the menu to the selected element
	CannedMenu.style.top = xy[1] - document.getElementById('CannedMenu').offsetHeight;

	if (sType)
	{
		MenuItems = CannedMenu.firstChild.rows[0].cells[1].firstChild.childNodes;

		for ( var i = 0; i < MenuItems.length; i++)
		{
			if (MenuItems[i].id == sType)
			{
				MenuItems[i].style.display = '';
			}
			else
			{
				MenuItems[i].style.display = 'none';
			}
		}
	}
}

function DeSelect(TextArea)
{
	PreventClose = 0; // Unless over-ridden, the comment menu should be closed
	setTimeout('CloseCommentMenu ()', 250); // Set a timer to make sure that
	// the onclick event
	// (InsertComment) occurs before
	// the menu gets closed.
}

function InsertComment(Comment)
{
	if (SelectedTextArea == 0)
	{
		return;
	}

	for ( var i = 0; (i < Comment.length) && (Comment[i] != -1); i++)
	{
		SelectedTextArea.value += String.fromCharCode(Comment[i]); // append
		// the
		// canned
		// comment
	}

	PreventClose = 0; // disable any overrides

	CloseCommentMenu(); // close the menu
}

function findPos(obj)
{
	var curleft = 0;
	var curtop  = 0;
	if (obj.offsetParent)
	{
		curleft = obj.offsetLeft;
		curtop = obj.offsetTop;
		while (obj = obj.offsetParent)
		{
			curleft += obj.offsetLeft;
			curtop += obj.offsetTop;
		}
	}
	return
	[curleft, curtop];
}

// To avoid complications due to undefined constants... (IE!)
if (!document.ELEMENT_NODE)
{
	document.ELEMENT_NODE = 1;
	document.ATTRIBUTE_NODE = 2;
	document.TEXT_NODE = 3;
	document.CDATA_SECTION_NODE = 4;
	document.ENTITY_REFERENCE_NODE = 5;
	document.ENTITY_NODE = 6;
	document.PROCESSING_INSTRUCTION_NODE = 7;
	document.COMMENT_NODE = 8;
	document.DOCUMENT_NODE = 9;
	document.DOCUMENT_TYPE_NODE = 10;
	document.DOCUMENT_FRAGMENT_NODE = 11;
	document.NOTATION_NODE = 12;
}

// Because not all browsers (IE!) implement the importNode function for DOM
// objects
if (!document.importNode)
{
	document.importNode = function(node, allChildren)
	{
		var newNode;

		switch (node.nodeType)
		{
			case document.ELEMENT_NODE :
				newNode = document.createElement(node.nodeName);
				if (node.attributes)
				{
					for ( var i = 0; i < node.attributes.length; i++)
					{
						newNode.setAttribute(node.attributes[i].nodeName, node.getAttribute(node.attributes[i].nodeName));
					}

					if (allChildren && node.childNodes)
					{
						var childNode = node.firstChild;
						while (childNode)
						{
							var newChild = document.importNode(childNode, true);
							newNode.appendChild(newChild);
							childNode = childNode.nextSibling;
						}
					}
				}
				break;

			case document.CDATA_SECTION_NODE :
				newNode = document.createCDATASection(node.nodeValue);
				break;

			case document.COMMENT_NODE :
				newNode = document.createComment(node.nodeValue);
				break;

			default :
				newNode = document.createTextNode(node.nodeValue);
				break;
		}

		return newNode;
	};
}

function ToggleSection(strImage, strDiv, strCookie)
{
	var Expanded;
	var Div = document.getElementById(strDiv);

	// Check if the DIV is already displayed
	if (Div.style.display == "none")
	{
		ExpandSection(strImage, strDiv, strCookie);
		Expanded = true;
	}
	else
	{
		// We need to hide the DIV
		Div.style.display = "none";
		// And we need to change the image to the PLUS
		var Img = $('[id*=' + strImage + ']');
		if (Img)
		{
			Img.attr('src' , '/Images/Plus.gif');
		}
		Expanded = false;
	}

	// Make sure the unhidden lists get redisplayed properly
	GlobalList.OnResize();

	return Expanded;
}

function ExpandSection(strImage, strDiv, strCookie)
{
	// We need to display the DIV
	var Div = document.getElementById(strDiv);
	Div.style.display = "";
	// And we need to change the image to the MINUS
	var Img = $('[id*=' + strImage + ']');
	if (null !== Img)
	{
		Img.attr('src' , '/Images/Minus.gif');
	}

	if (FunctionExists(ImageLoad))
	{
		ImageLoad(Div);
	}
}

function escapeXML(str)
{
	var div = document.createElement('div');
	var text = document.createTextNode(str);
	div.appendChild(text);
	return div.innerHTML;
}

function strpbrk(haystack, char_list)
{
	var retVal = -1;
	for ( var i = 0; i < char_list.length; i++)
	{
		var pos = haystack.indexOf(char_list.charAt(i));
		if (pos > -1)
		{
			if ((retVal == -1) || (pos < retVal))
			{
				retVal = pos;
			}
		}
	}
	return retVal;
}

// Return true if function exist in current load
// FuncName can either be a function object, or a string containing the name
// of the function
function FunctionExists(FuncName)
{
	if (undefined === FuncName)
	{
		return false;
	}
	// first check for FuncName being a function
	if (typeof FuncName == 'function')
	{
		return true;
	}
	// FuncName is not a function, check for string that contains the name of a
	// function
	if (eval('typeof ' + FuncName) == 'function')
	{
		return true;
	}
	return false;
}

// Bind enter key to click action of btnSubmit in forms on pages AssignToXXX.php
function ProcessEnterKey(event, element)
{
	if ((event.which ? event.which : event.keyCode) === 13)
	{
		if (element.tagName !== 'TEXTAREA')
		{
			var inputButton = document.getElementById('btnSubmit');
			if ((typeof (inputButton) != 'undefined') && (inputButton != null))
			{
				inputButton.click();
				return false;
			}
			else
			{
				if (document.getElementById('SaveAllBottom'))
				{
					element.onchange();
					event.preventDefault();
					document.getElementById('SaveAllBottom').click();
					return false;
				}
				else
				{
					return true;
				}
			}
		}
	}
	return true;
}

// Ensure user has entered an integer number
function CheckForInteger(e)
{
	var key;
	if (document.all)
	{
		// IE
		key = window.event.keyCode;
	}
	else
	{
		// Firefox
		if (e.keyCode)
		{
			key = e.keyCode;
			if ((key == 8) || (key == 9))
			{
				// BackSpace or Tab (not passed in IE)
				return true;
			}
		}
		else
		{
			// key = e.which;
			key = e.charCode;
		}
	}

	if ((key >= 0x30) && (key <= 0x39))
	{
		// 0 - 9
		return true;
	}

	if (key == 13)
	{
		// Return
		blur(); // loose focus on this widget (force an onchange())
		return true;
	}

	return false;
}

function CheckValue2(elm)
{
	var field = elm.nextSibling;
	while (field)
	{
		if (field.name == 'FieldValue2[]')
		{
			if (elm.value == "Range")
			{
				field.style.display = '';
			}
			else
			{
				field.style.display = 'none';
				field.value = '';
			}
			break;
		}
		field = field.nextSibling;
	}
}

function ShowMessage(val)
{
	var sub = document.getElementById(val);

	sub.style.display = "block";
	sub.style.color = "#ff4444";
}
function HideMessage(val)
{
	var sub = document.getElementById(val);
	sub.style.display = "none";
}

function GetLowestAccessLevel(AccessLevel1, AccessLevel2)
{
	if ((AccessLevel1 == 'None') || (AccessLevel2 == 'None'))
	{
		return 'None';
	}
	if ((AccessLevel1 == 'Read') || (AccessLevel2 == 'Read'))
	{
		return 'Read';
	}
	if ((AccessLevel1 == 'Full') || (AccessLevel2 == 'Full'))
	{
		return 'Full';
	}
	return 'Default';
}

function AnalyzeMontageClick()
{
	if (hasClass(document.getElementById('AnalyzeLink'), 'Disabled'))
	{
		return false;
	}
	var status = document.getElementById('MontageStatus').innerHTML;
	status = status.replace('\n', '');
	if (status == 'Montage Complete')
	{
		return true;
	}
	else if (MontageIsInvalid(status))
	{
		alert(status + "\nYou must be recreate the montage before it can be analyzed.");
	}

	return false;
}

function MontageIsInvalid(status)
{
	return status.substr(0, 22) == 'The montage is invalid';
}

function CheckForURL(Field, AllowBlank, AllowRelative)
{
	if (Field.value.substring(0, 2) == '//')
	{
		return true;
	}
	if (AllowBlank && (Field.value == ''))
	{
		return true;
	}
	if (AllowRelative && (Field.value.substring(0, 2) == './'))
	{
		return true;
	}
	alert("Invalid URL");
	return false;
}

function CheckForUNC(Field)
{
	if (Field.value.substring(0, 2) == '\\\\')
	{
		var pos = Field.value.indexOf('\\', 3);
		if ((pos >= 3) && (pos < Field.value.length - 1))
		{
			return true;
		}
		alert("Path must include a folder");
		return false;
	}
	if ((Field.value == '*') || (Field.value == ''))
	{
		return true;
	}
	alert("Path must start with \\\\");
	return false;
}

function UpdateReportTemplates(Table)
{
	var customer = this.document.getElementsByName("CustomerId")[0];
	var template = this.document.getElementsByName('Template')[0];
	if (isset(customer) && isset(template))
	{
		var len = template.length;
		for (var i = 1; i < len; i++)
		{
			template.remove(1);
		}
	}
	HTTPRequest('GetReportTemplates.php', 'POST', 'Table=' + Table + '&CustomerName=' + customer.value, ReceiveReportTemplatesAJAX);
}

function ReceiveReportTemplatesAJAX(http_request)
{
	if ((http_request.readyState == 4) && (http_request.status == 200))
	{
		try
		{
			// generateDiv contains the bulk task for generating reports
			var generateDiv = $('#divShowReportsCase .BulkTasks a:contains("Generate Report")').closest('div');
			var select = $('select#Template')[0];
			if (undefined === select)
			{
				// at this point, generateDiv contains only the <a>
				// 
				// build HTML for generating reports of the form:
				//		<div>   <-- this is generateDiv
				//			<a>Generate Report</a>
				//			<textnode> </textnode>
				//			<div style="display:none; margin:0; padding:0">
				//				<select></select>
				//			</div>
				//		</div>

				// this text node is required by BulkActionOption() in List.js
				generateDiv.append(document.createTextNode(' '));
				var newDiv = $('<div style="display:none; margin:0; padding:0"><select id="Template" name="Template" onchange="ListActionOption(this); return false;" message="" ></select></div>');
				generateDiv.append(newDiv);
				select = newDiv.find('select#Template')[0];
				var option = document.createElement('option');
				option.text = '--Select--';
				select.add(option);
			}
			var Data = eval('(' + http_request.responseText + ')');
			// Sometimes this code gets executed twice resulting in
			// duplicated dropdown items. To be safe, clear the list
			// again.
			var len = select.length;
			for (var i = 1; i < len; i++)
			{
				select.remove(1);
			}

			var found = false;
			for (var i = 0; i < Data.length; i++)
			{
				if (Data[i]['Assigned'] == '1')
				{
					found = true;
					var option = document.createElement("OPTION");
					option.text = Data[i]['Description'];
					option.value = Data[i]['Name'];
					select.add(option, null);
				}
			}
			if (!found)
			{
				// remove the text node and the div that contains the select,
				// but preserve the <a>
				var a = generateDiv.find('a').detach();
				generateDiv.empty();
				generateDiv.append(a);
			}
		}
		catch (e)
		{
		}
	}
}

function showElement(id, box)
{
	var vis = (box.checked) ? "block" : "none";
	document.getElementById(id).style.display = vis;
}

function setRoleFromSelect(select)
{
	document.body.style.cursor = "wait";
	var CombinedIds = $(select).find(":selected").val();
	// CombinedIds is RoleId|HierarchyId
	var Ids = CombinedIds.split('|');
	// call SetSessionVars.php to recreate the $_SESSION array using the
	// selected RoleId
	var PALmode = isPALMode() ? '1' : '0';
	HTTPRequest('/SetSessionVars.php', 'POST', 'AJAX=1&RoleId=' + Ids[0] + '&HierarchyId=' + Ids[1] + '&ResetSession=1&PALMode=' + PALmode, ReceiveSetSessionVarsAJAX);
}

function isPALMode()
{
	return isset(window.PALMode) && true === window.PALMode;
}
function ReceiveSetSessionVarsAJAX(http_request)
{
	if ((http_request.readyState == 4) && (http_request.status == 200))
	{
		var response = jQuery.trim(http_request.responseText);
		if (response == 'OK')
		{
			window.location.reload(); // refresh current page
		}
		else if (response.substring(0, 5) == 'page=')
		{
			window.location.assign(response.substr(5));
		}
		else
		{
			document.body.style.cursor = "default";
		}
	}
}

function CopyObject(obj)
{
	return JSON.parse(JSON.stringify(obj))
}

function DisableElements(Selector)
{
	$(Selector).attr('disabled', 'disabled').addClass('ui-state-disabled');
}
function EnableElements(Selector)
{
	$(Selector).removeAttr('disabled').removeClass('ui-state-disabled');
}
